import {
   EXPERTS_LINK_EDIT_REQUEST,
   EXPERTS_LINK_EDIT_RESPONSE,
   EXPERTS_LINK_EDIT_FAILURE
} from "../../actions/types";

const initialState = {
    isLoading: false,
    error: false,
    msg: ''
};

const setFetching = (state, action) => {

    const { email, password } = action.payload;

    return {
        ...state,
        isLoading: true,
        error: false,
        msg: ''
    };

};

const setResponse = (state, action) => {
   
    return {
        error: false,
        msg: '',
        isLoading: false
    }
}

const setFailure = (state, action) => {
    return {
        error: true,
        msg: "Something Went Wrong Couldn't Update the Changes.",
        isLoading: false
    }
}

const EditLinksReducer = (state = initialState, action) => {
    switch (action.type) {
        case EXPERTS_LINK_EDIT_REQUEST:
            return setFetching(state, action);
            break;

        case  EXPERTS_LINK_EDIT_RESPONSE:
            return setResponse(state, action);
            break;
        
        case EXPERTS_LINK_EDIT_FAILURE:
            return setFailure(state, action);
            break;

        default:
            return state;
            break;
    }
};

export default EditLinksReducer;
